module.exports = __webpack_public_path__ + "img/clients-bg-left.8cbb6b4b.png";